import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface DescriptionItem {
  label: string;
  value: ReactNode;
  /** Spans both columns - for addresses and free-text remarks. */
  wide?: boolean;
}

export interface DescriptionListProps {
  items: DescriptionItem[];
  columns?: 1 | 2 | 3;
  className?: string;
}

/** Label/value pairs for read-only detail panels. */
export function DescriptionList({ items, columns = 2, className }: DescriptionListProps) {
  return (
    <dl
      className={cn(
        'grid gap-x-6 gap-y-3',
        columns === 1 && 'grid-cols-1',
        columns === 2 && 'grid-cols-1 sm:grid-cols-2',
        columns === 3 && 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
        className,
      )}
    >
      {items.map((item) => (
        <div key={item.label} className={cn('min-w-0', item.wide && 'sm:col-span-full')}>
          <dt className="text-2xs tracking-wide text-content-muted uppercase">{item.label}</dt>
          <dd className="mt-0.5 text-sm break-words text-content">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
